<div class="flex flex-col md:flex-row min-h-screen bg-white">
  <!-- Sidebar para desktop -->
  <app-sidebar [circleNumber]="1" (backClick)="goBack()" class="bg-teu-purple hidden sm:block relative w-full md:w-[197px] h-[120px] md:h-auto flex-shrink-0 overflow-hidden"></app-sidebar>
  
  <!-- Header para móvil -->
  <app-header [circleNumber]="1" (backClick)="goBack()"></app-header>

  <!-- Main Content -->
  <div class="flex-1 flex flex-col">
    <!-- Bloque central con fondo verde, centrado -->
    <div class="flex-1 bg-lime flex items-start md:items-center justify-center pt-[60px] md:pt-0">
      <div class="w-full max-w-[760px] mx-auto px-4 sm:px-6 md:px-8 text-center">
        <!-- Logo -->
        <div class="flex justify-center mb-6 md:mb-10">
          <div [innerHTML]="logoSvg" class="w-[100px] md:w-[120px]"></div>
        </div>

        <!-- Título -->
        <h1 class="text-[26px] md:text-[36px] font-extrabold text-[#1E1349] mb-4">
          Estamos evaluando tu<br class="hidden md:block"/> aplicación
        </h1>

        <!-- Subtítulo -->
        <p class="text-base md:text-lg font-semibold text-[#1E1349] mb-2">
          Ya puedes relajarte
        </p>

        <!-- Descripción -->
        <p class="text-sm md:text-base text-[#1E1349] max-w-[560px] mx-auto mb-8 md:mb-10">
          En un lapso no mayor a 48 hr recibirás una notificación y un correo electrónico con la respuesta a tu aplicación.
        </p>

        <!-- Botón Aceptar -->
        <div class="flex justify-center">
          <button type="button" class="btn-primary w-[220px] h-[46px]" (click)="onFinish()">
            Aceptar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>